/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const prodottiAPI = {
  // Catalogo tipi
  listaTipi: async () => { const { data } = await apiClient.get('/prodotti/admin/tipi'); return data; },
  creaTipo: async (body) => { const { data } = await apiClient.post('/prodotti/admin/tipi', body); return data; },
  // Manutenzioni di un tipo
  manutenzioniTipo: async (tipoId) => { const { data } = await apiClient.get(`/prodotti/admin/tipi/${tipoId}/manutenzioni`); return data; },
  creaManutenzioneTipo: async (tipoId, body) => { const { data } = await apiClient.post(`/prodotti/admin/tipi/${tipoId}/manutenzioni`, body); return data; },
  // Prodotti installati per cliente
  prodottiCliente: async (clienteId) => { const { data } = await apiClient.get('/prodotti/cliente', { params: { cliente_id: clienteId } }); return data; },
  detail: async (id) => { const { data } = await apiClient.get(`/prodotti/${id}`); return data; },
  installa: async (body) => { const { data } = await apiClient.post('/prodotti/admin/installa', body); return data; },
  registraManutenzione: async (prodottoId, body) => { const { data } = await apiClient.post(`/prodotti/${prodottoId}/manutenzioni/registra`, body); return data; },
  // Lista clienti per il form
  scadenzeAdmin: async () => { const { data } = await apiClient.get('/prodotti/scadenze/admin'); return data; },
  clienti: async () => { const { data } = await apiClient.get('/prodotti/admin/clienti'); return data; },
};
